import { isKnownBrowseDimensionKey } from './browsePath';

const normalizeValueSlug = (slug: string): string => decodeURIComponent(slug).toLowerCase().trim();

/** Origin facet value slugs from legacy `/c/{top}/{value}/{id}/{id}/` URLs (url-safe). */
const ORIGIN_VALUE_SLUGS = new Set([
    'african',
    'american',
    'ancient-egyptian',
    'ancient-greek-and-roman',
    'asian',
    'byzantine',
    'catholic',
    'chinese',
    'egyptian',
    'european',
    'german',
    'indian',
    'japanese',
    'korean',
    'middle-eastern',
    'murano',
    'native-american',
    'oceanicpacific-rim',
    'persian',
    'southeast-asian',
    'tibetan',
]);

/** Material facet value slugs from legacy combo URLs. */
const MATERIAL_VALUE_SLUGS = new Set([
    '18k-gold',
    'argillite',
    'bronze',
    'brass',
    'carnival-glass',
    'cloisonne',
    'copper',
    'fabric',
    'fur',
    'glass',
    'gold',
    'jade',
    'oil',
    'pearl',
    'pencil',
    'pietra-dura',
    'porcelain',
    'pottery',
    'silver',
    'sterling-silver',
    'stoneware',
    'tin',
    'titanium',
    'wood',
    'woodblock',
]);

/** Style facet value slugs from legacy combo URLs. */
const STYLE_VALUE_SLUGS = new Set([
    'art-deco',
    'bronze-age',
    'chippendale',
    'confederate',
    'contemporary',
    'federal-style',
    'folk-art',
    'han-dynasty',
    'hollywood-regency',
    'mid-century-modern',
    'ming-dynasty',
    'mission-style',
    'modern',
    'primitive',
    'qing-dynasty',
    'queen-anne',
    'rococo',
    'soviet',
    'victorian',
]);

/**
 * Top-level category slugs whose legacy `/c/{slug}/{id}/{id}/` URLs should canonicalize to
 * `/c/{slug}/material/{slug}/` (e.g. `/c/silver/25869/25902/`).
 */
export const MATERIAL_SELF_CATEGORY_SLUGS = new Set([
    'argillite',
    'bullion',
    'carnival-glass',
    'pietra-dura',
    'silver',
    'sterling-silver',
    'stoneware',
    'titanium',
]);

/**
 * Infers browse dimension for legacy `/c/{top}/{value}/{d1}/{d2}/` when the middle segment is a facet
 * value slug (not an explicit dimension key). Returns `null` when unknown (e.g. creator names) so
 * `resolve-browse-url` can still classify via the numeric tail.
 */
export const inferLegacyBrowseDimensionForValueSlug = (valueSlug: string): string | null => {
    const value = normalizeValueSlug(valueSlug);
    if (!value || isKnownBrowseDimensionKey(value)) {
        return null;
    }
    if (MATERIAL_VALUE_SLUGS.has(value)) {
        return 'material';
    }
    if (ORIGIN_VALUE_SLUGS.has(value)) {
        return 'origin';
    }
    if (STYLE_VALUE_SLUGS.has(value)) {
        return 'style';
    }
    return null;
};
